<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import { required } from "vuelidate/lib/validators";
// import Vuetable from 'vuetable-2'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Vue from "vue";
import axios from "axios";
import { FulfillingBouncingCircleSpinner } from 'epic-spinners'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import moment from "moment";
import 'boxicons/css/boxicons.min.css';
import 'boxicons';
// import DatePicker from "vue2-datepicker";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
Vue.component('v-select', vSelect)

// register the plugin on vue
import Toasted from 'vue-toasted';

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Departamento component
 */
export default {
  page: {
    title: "Asignacion Lote Animal",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {Layout, Loader,
    // Vuetable,
    VuetablePagination, "fulfilling-bouncing-circle-spinner":FulfillingBouncingCircleSpinner},
  data() {
    return {
        showModalN: false,
      userT : this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token}
      },
      metododeBusqueda:false,
      fecha_inicio: "",
      rangode_fecha:"",
      fecha_fin:"",
      repit : true,
      fields: [
        {
          name: "lote.no_lote",
          title: "No. Lote",
          sortField: "lote.no_lote",
          width: "20%",
        },
        {
          name: "lote.no_animales",
          title: "No. Animales",
          sortField: "lote.no_animales",
          width: "20%",
        },
        {
          name: "lote.fecha_inicio",
          title: "No. Lote",
          sortField: "lote.fecha_inicio",
          width: "20%",
        },
        {
          name: "tipo_lote",
          title: "Tipo Lote",
          sortField: "tipo_lote",
          width: "20%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "10%",
        },
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        },
      ],
      apiUrl: process.env.VUE_APP_URL,
      // apiBase: process.env.VUE_APP_URL +"compras/get?tienda=" + this.$store.state.authfack.user.tienda,
      apiBase: process.env.VUE_APP_URL +"asignacion_alimento/viewAllDetalle?concentradoId="+this.$route.params.id ,
       css: {
      table: {
        tableClass: 'table table-striped table-bordered table-hovered',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      pagination: {
        infoClass: 'pull-left',
        wrapperClass: 'vuetable-pagination pull-right',
        activeClass: 'btn-primary',
        disabledClass: 'disabled',
        pageClass: 'btn btn-border',
        linkClass: 'btn btn-border',
        icons: {
          first: '',
          prev: '',
          next: '',
          last: '',
        },
      }
    },
      formDepa: {
        nombre: "",
        id: 0,
      },
      tiendasData:[],
      updating: false,
      estadotabla:true,
      title:"Asignacion Lote Animal",
      itemst: [
        {
          text: "Asignacion Lote Animal",
          href: "/",
        },
        {
          text: "Lista de Compras de Concentrado",
          active: true,
        },
      ],
   
       searchType: [
        { nombre: "No. Corral", value: "no_corral" },
      ],
      options : {
          theme: "outline",  
          position: "top-right", 
          duration : 5000,
          keepOnHover:true,
          action : {
            text : 'X',
            onClick : (e, toastObject) => {
                toastObject.goAway(0);
          },
         
    },
      },
       loadingtable:false,
       sortBy: "no_corral",
       sortDesc: false,
       searchLabel: { nombre: "No. Corral", value: "no_corral" },
       filterLabel: { nombre: "No. Corral", value: "no_corral" },
       showModalL: false, //Loading
       showModalD: false, //Desactivar
       showModalA: false, //Activar
       data:[],
       vanderaExistencia: false,
       pageOptions: [4, 10, 15, 20],
       search: "",
        page: 1,
        perPage: 20,
        from: 0,
        to: 0,
        total: 0,
        lastPage: 0,
        arrayAlimento: [],
        formComida: { cantidad: "",    
             cantidad_sugerida:"", id : 0, no_lote: 0, 
             concentradoid:0 ,
             inversion_comida:0,inversion_economica:0, precio_compra: 0 },
        nombre_producto : this.$route.params.nombre_producto,
    };
  },
  validations: {
    formDepa: {
      nombre: { required},
    },
    formComida : {
        cantidad: {required},
        cantidad_sugerida: {required},
    }
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
        this.getLotes(this.page, this.search);
    }
   
  },
   watch: {
  
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    formatoPresentacion(date) {
      return moment(date).locale("es").format("LL");
    // return moment(date).locale("es").format("LLLL");
    },

    async getLotes(page, search){
        try {
          console.log(search, this.apiBase)
        const response = await axios.get(this.apiBase, {
          params: {
            page:page,
            limite: this.perPage,
            search: search
          }, headers: { "x-token": this.userT.token },
        });
        // console.log(response);
        this.arrayAlimento = response.data.data;
        this.onPaginationData(response.data);
        // this.totalItems = response.data.total;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
     customFormatter(date) {
      return moment(date).format('YYYY-MM-DD');
    },
     limpiarfiltro(){
        let me = this;
        me.fecha_inicio = "";
        me.fecha_fin = "";
    },
    separarfechas(){
      this.fecha_inicio=this.rangode_fecha[0]
      this.fecha_fin=this.rangode_fecha[1]
    },
  activarBuscadorFechas(search ,index){
      this.metododeBusqueda = (index == 3) ? true : false;
    },
   // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
showDate(date) {
 return moment(date).locale("es").utc().format("MMM Do YYYY");
 },

    //Desactivar registro
  
    //Activar registro
  


   //Buscador dentro de la tabala
    onFiltered(){
        // console.log('aqui')
      this.search = this.search.toLowerCase();
    //   this.$refs.vuetable.refresh();
    },
   //enviar datos a la Paginacion
   onPaginationData(paginationData) {
    // console.log(paginationData)
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
    //   this.arrayAlimento = this.items;
    // console.log(paginationData.to)
      this.$refs.pagination.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
        // console.log('aqui')
    //   this.$refs.vuetable.refresh();
        this.getLotes(this.page, this.search);
    },
   async changeTypeDates(){
    // console.log('aqui')
    //   await this.separarfechas()
      // console.log(this.fecha_inicio, this.fecha_fin);
    //   this.$refs.vuetable.refresh();
    this.getLotes(this.page, this.search);
    },
    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
        // console.log(type)
      this.fecha_inicio = (type.value == "fecha") ? '' : ''
      this.fecha_fin = (type.value == "fecha") ? '' : '';
      this.searchLabel = type;
    //   this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
        // console.log(page)
        this.getLotes(page, this.search);
    //   this.$refs.vuetable.changePage(page);

    },
     //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
        // console.log(sortOrder, currentPage)
    
      return sortOrder[0]
        ? {
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            criterio: sortOrder[0] ? sortOrder[0].sortField : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            criterio: sortOrder[0] ? sortOrder[0].sortField : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          };
    },
  //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
 openModal(model) {
      switch (model) {
        case "save": {
       this.$v.$reset();
      this.limpiarVariables();
         
      // console.log("entrando a resetear")
          break;
        }
        case "update": {
       this.$v.$reset();
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
limpiarVariables(){
   this.formDepa.id=0;
   this.formDepa.nombre="";
},
 //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
 closeModal(model) {
      switch (model) {
        case "save": {
         this.showModalN=false;
          this.showmodalL = false;
          break;
        }
         case "update": {
           this.showModalE=false;
          this.showmodalL = false;
          break;
        }
      }
    },

    //Para abrir los modales y pasar los datos de la fila o limpiar valores
   
    viewLoteAnimal(id){
 
        this.$router.push({ name: 'vista_lote', params: { id: id } });
    },
    async validaciones() {
      this.submitted = true;

      this.$v.$touch();
      if (!this.$v.$invalid) {
          // console.log('esta pasando')
        return;
      } else {
        if(this.formComida.cantidad == '' || this.formComida.cantidad <= 0 || isNaN(this.formComida.cantidad))
          {     
            Vue.toasted.error("Ingresa un valor valido", this.options);
          return;
        }else{
         await  this.validarExistencia();
          console.log(this.vanderaExistencia)
          if(this.vanderaExistencia)
              this.save();
        }
        console.log('esta pasando')
        

      }
    },
    async validarExistencia() {
      const {  cantidad, concentradoid } = this.formComida;
      
      try{
        this.vanderaExistencia = false;
       await axios
        .post(process.env.VUE_APP_URL + "concentrado/valida_existencia", {
            id : concentradoid, cantidad
        }, {
                headers: { "x-token": this.userT.token },
              });
              this.submitted = false;
          this.vanderaExistencia = true;
          this.showModalL = false
            

      }catch(error){
        if (error.response && error.response.data) {
            this.errorMessage = error.response.data.error; 
            // Accede al mensaje de error dentro de la respuesta
            } else {
            this.errorMessage = 'Error desconocido'; 
            }
            
            Vue.toasted.error(this.errorMessage, this.options);
      }
              
    },
    save() {
      const {  cantidad, id ,no_lote,precio_compra, concentradoid} = this.formComida;
      this.showModalL = true;
      const inversion_comida = parseFloat(cantidad);
      const inversion_economica = parseFloat(cantidad) * precio_compra;
      axios
        .put(process.env.VUE_APP_URL + "asignacion_alimento/echarComida", {
            id, inversion_comida, inversion_economica,
            estado_comida: true,concentradoid,
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
            // console.log(response);
          Vue.toasted.success(no_lote + " Guardado", this.options);
          this.showModalN = false;
          this.limpiarModal();
          this.submitted = false;

          
          this.getLotes(this.page, this.search);
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false
        });
    },
    limpiarModal(){
        this.formComida.cantidad_sugerida = '';
        this.formComida.no_lote = '';
        this.formComida.precio_compra = '';
        this.formComida.id = '';
    },
    onActionClicked(action,data) {
        // console.log(data);
      if (action == "edit-item") {
        this.showModalE = true;
      }
      if (action == "new-item") {
        // console.log( data.no_animales);

        this.showModalN = data.estado_comida == false && data.lote.no_animales > 0 ? true : false;
        this.formComida.cantidad_sugerida = data.cantidad_sugerida;
        this.formComida.no_lote = data.lote.no_lote;
        this.formComida.precio_compra = parseFloat(data.concentrado.precio_compra);
        this.formComida.id = data.id;
        this.formComida.concentradoid =data.concentrado.id;
      }
    },
    eliminarDetalle(index) {
      this.arrayDetalle.splice(index, 1);
    },
    loteStyle(estado) {
      return {
        backgroundColor: estado === false? '#f94144' : '#90be6d',
        filter: 'brightness(1.1)',
        border: '5px solid #457b9d'
      };
    }
  },
   computed: {
    ...authComputed,
    ...mapState("authfack", ["status"])
    /**
     * Total no. of records
     */
  
    }
};
</script>

<template>
  <Layout>

    <div class="row">
      <div class="col-12">


            <b-modal
              centered
              v-model="showModalL"
              title-class="text-black font-18"
              body-class="p-3"
              hide-footer
              no-close-on-backdrop
             content-class="my-class"
             header-class="my-class"
                  >
                    <template #modal-header="">
                <!-- Emulate built in modal header close button action -->
                  
                  <h5></h5>
                </template>
                    <form>
                      <div class="row">
                        <div class="col-12">
                          <div class="d-flex justify-content-center">
                            
                         <fulfilling-bouncing-circle-spinner
                          :animation-duration="2000"
                          :size="90"
                          color="#2a3042"
                          />
                          </div>
                        </div>
                      
                       
                      </div>

                      
                    </form>
            </b-modal>
            <b-modal
  centered
  v-model="showModalN"
  title="Nueva Concentrado"
  title-class="text-black font-18"
  body-class="p-4 modal-responsive-body modal-lg"
  hide-footer
>
  <form @submit.prevent="validaciones('save')">
    <div class="row">
      <div class="col-12">
        <div class="mb-4">
          <label for="name" class="label-xl">Cantidad Sugerida en Lb</label>
          <input
            disabled
            id="name"
            v-model="$v.formComida.cantidad_sugerida.$model"
            type="text"
            class="form-control form-control-xl"
          />
        </div>
      </div>
      <div class="col-12">
        <div class="mb-4">
          <label for="name" class="label-xl">Ingrese Alimento En Libras</label>
          <input
            id="name"
            v-model="$v.formComida.cantidad.$model"
            type="text"
            class="form-control form-control-xl"
            placeholder="Ingrese Alimento"
            :class="{
              'is-invalid': $v.formComida.cantidad.$error,
            }"
            @input="$v.formComida.cantidad.$touch()"
          />
          <div
            v-if="
              $v.formComida.cantidad.$error &&
              !$v.formComida.cantidad.required
            "
            class="invalid-feedback feedback-xl"
          >
            Por favor ingresa la comida
          </div>
        </div>
      </div>
    </div>

    <div class="text-end pt-5 mt-4">
      <b-button variant="light" @click="showModalN = false" size="lg"
        >Cerrar</b-button
      >
      <b-button type="submit" variant="success" class="ms-1" size="lg"
        >Guardar</b-button
      >
    </div>
  </form>
</b-modal>
         <div class="card">
          <div class="card-body">
            <h2 class="card">{{nombre_producto}}</h2>
            <div class="row align-items-center header-options-container">
  <div class="col-sm-12 col-md-2">
    <div id="tickets-table_length" class="dataTables_length">
      <label class="d-inline-flex align-items-center elegant-select-label">
        Mostrar&nbsp;
        <b-form-select
          class="elegant-select form-select-sm"
          v-model="perPage"
          @input="changePageSize(); getLotes(page, search);"
          size="sm"
          :options="pageOptions"
        ></b-form-select>
      </label>
    </div>
  </div>

  <div class="col-sm-12 col-md-2">
    <div id="tickets-table_length" class="dataTables_length text-md-end">
      <label class="d-inline-flex align-items-center elegant-dropdown-label">
        <b-dropdown
          v-if="searchType"
          id="ddown1"
                size="md"
                class="elegant-dropdown w-100"
        >
          <template v-slot:button-content>
            {{ 'Ordenar por: ' + searchLabel.nombre }}
            <i class="mdi mdi-chevron-down"></i>
          </template>
          <b-dropdown-item
            v-for="(search, index) in searchType"
            :key="index"
            @click="changeTypeSearch(search); getLotes(page, search); activarBuscadorFechas(search, index); limpiarfiltro();"
          >
            {{ search.nombre }}
          </b-dropdown-item>
        </b-dropdown>
      </label>
    </div>
  </div>

  <div class="col-sm-12 col-md-3 text-md-start">
    <div id="tickets-table_length" class="dataTables_length">
      <label class="d-inline-flex align-items-center elegant-input-label">
        <b-form-input
          v-model="search"
          type="search"
          @input="onFiltered(); getLotes(page, search)"
          placeholder="Buscar..."
          class="elegant-input form-control-sm"
        ></b-form-input>
      </label>
    </div>
  </div>

  <div class="col-sm-12 col-md-5">
    <div id="tickets-table_filter" class="dataTables_filter text-md-end">
      <label class="d-inline-flex align-items-center">
        <router-link :to="{ name: 'listado_lotes_alimento' }">
          <button
            v-b-modal.modalSave
            type="button"
            class="btn btn-success btn-rounded mb-2 me-2 elegant-button"
          >
            <i class="mdi mdi-plus me-1"></i> Regresar
          </button>
        </router-link>
      </label>
    </div>
  </div>
</div>

            <!-- Table -->
            <Loader :loading="loadingtable">
    <div class="container-fluid">
      <div class="row">
        <div v-for="(lote) in arrayAlimento" :key="lote.id" class="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-5">
          <div class="card larger-card h-100" :style="loteStyle(lote.estado_comida)" @click="onActionClicked('new-item', lote)">
            <div class="card-body elegant-card p-5 d-flex flex-column justify-content-center align-items-center">
              <div class="product-name text-center mb-3">
                Tipo Corral  ({{ lote.lote.tipo_lote }})
              </div>
              <div class="product-name text-center mb-3">
                Corral  ({{ lote.lote.no_lote }})
              </div>
              <div class="product-name text-center mb-3">
                Total Animales  ({{ lote.lote.no_animales }})
              </div>
              <div class="product-name text-center mb-3">
                Porción ({{ lote.cantidad_sugerida + ' LB' }})
              </div>
              <div class="elegant-card pigs">
                <i class="icon fas fa-piggy-bank"></i>
            
                <!-- <p>Cerdos</p> -->
              </div>
              <!-- <div class="icon-group text-center mt-auto"> -->
                <!-- <box-icon type="solid" name="dog" size="md" class="mr-3"></box-icon> -->
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding-top: 20px">
      <vuetable-pagination
        ref="pagination"
        :css="css.pagination"
        @vuetable-pagination:change-page="onChangePage"
        class="elegant-pagination"
      ></vuetable-pagination>
    </div>
  </Loader>
          
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>



<style scoped>
.modal-responsive-body {
  max-height: 75vh;
  overflow-y: auto;
}

.label-xl {
  font-size: 1.5rem;
}

.feedback-xl {
  font-size: 1.2rem;
}

.form-control-xl {
  font-size: 1.3rem;
  padding: 1.2rem;
}

@media (max-width: 768px) {
  .modal-responsive-body {
    padding: 2rem;
  }

  .label-xl {
    font-size: 1.2rem;
  }

  .form-control-xl {
    font-size: 1.2rem;
  }

  .feedback-xl {
    font-size: 1.1rem;
  }

  .text-end {
    text-align: center;
  }

  b-button {
    width: 100%;
    margin-top: 0.5rem;
  }
}

@media (min-width: 768px) {
  .modal-responsive-body {
    padding: 3rem;
  }

  b-button {
    width: auto;
  }
}

@media (min-width: 1024px) {
  .modal-responsive-body {
    padding: 3rem;
  }
}
body {
  overflow-y: hidden;
}
.container-fluid.no-scroll {
  overflow: hidden;
}
.icon {
  font-size: 2rem;
  margin-bottom: 1rem;
}
.list-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #333;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.header-container {
  background: linear-gradient(135deg, #f0f0f0, #d9d9d9);
  padding: 25px;
  border-radius: 25px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}
.elegant-select {
  border-radius: 12px;
  padding: 10px;
  font-size: 1rem;
}
.elegant-dropdown {
  border-radius: 12px;
  font-size: 0.8rem;   /* Reduce el tamaño de la fuente */
  padding: 0.25rem 0.5rem;  /* Ajusta el padding para hacerlo más pequeño */
}
.elegant-input {
  border-radius: 12px;
  padding: 10px;
  font-size: 1rem;
}
.larger-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 30px;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  background-size: cover;
  background-position: center;
  filter: brightness(1.2);
  border: 5px solid #457b9d;
}
.larger-card:hover {
  transform: scale(1.05);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
}
.elegant-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 30px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  text-align: center;
  transition: all 0.3s ease;
}


.product-name {
  background-color: rgba(0, 0, 0, 0.7);
  color: #ffffff;
  padding: 12px;
  border-radius: 12px;
  font-weight: bold;
  font-size: 1.3rem;
  max-height: 5em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.elegant-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  margin-top: 20px;
  padding: 15px;
  background-color: #f0f0f0;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.header-options-container {
  background: linear-gradient(135deg, #f0f0f0, #d9d9d9);
  padding: 20px;
  border-radius: 25px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  margin-bottom: 40px;
}
.elegant-select-label,
.elegant-dropdown-label,
.elegant-input-label {
  font-weight: bold;
  font-size: 0.1rem;
  color: #333;
}
.elegant-select,
.elegant-dropdown,
.elegant-input {
  border-radius: 12px;
  padding: 10px;
  font-size: 1rem;
  transition: all 0.3s ease;
}
.elegant-button {
  font-size: 1.2rem;
  padding: 10px 20px;
  border-radius: 25px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.elegant-button:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
}

@media (max-width: 576px) {
  .product-name {
    font-size: 1.1rem;
  }
}
</style>